<template>
  <div>
    <v-card class="ma-2">
      <v-card-title>
        MLB Fantasy Player Props
        <v-spacer></v-spacer>

        <v-col cols="12" md="4" sm="5">
          <v-row justify="center" align="center">
            <small>Confidence :</small> <br/>&nbsp;
            <v-col class="light-green caption text-center"
            ><span>Low </span></v-col
            >
            <v-col class="medium-green caption text-center"
            ><span>Medium </span></v-col
            >
            <v-col class="dark-green caption text-center"
            ><span>High </span></v-col
            >
          </v-row>
        </v-col>
        <v-spacer></v-spacer>

        <v-col cols="12" md="5" sm="3">
          <v-row align="center" justify="end">
            <!--            <v-col md="7" cols="7" sm="6">-->
            <!--              <v-text-field-->
            <!--                v-model="search"-->
            <!--                append-icon="mdi-magnify"-->
            <!--                label="Search Player"-->
            <!--                single-line-->
            <!--                dense-->
            <!--                outlined-->
            <!--                hide-details-->
            <!--              ></v-text-field>-->
            <!--            </v-col>-->

            <v-col cols="5" md="4" sm="3">
              <v-card-actions>
                <v-switch v-model="switch1" inset label="Props"></v-switch>
                <!--                <v-switch-->
                <!--                    class="px-2"-->
                <!--                    v-model="switch2"-->
                <!--                    :disabled="switch1 ? false : true"-->
                <!--                    inset-->
                <!--                    label="Confidence"-->
                <!--                    @change="enableConfidence"-->
                <!--                ></v-switch>-->
              </v-card-actions>
            </v-col>
          </v-row>
        </v-col>
      </v-card-title>

      <!-- //? hitters -->
      <template v-if="false">
        <v-card-subtitle class="overline font-weight-bold">
          Hitter
        </v-card-subtitle>
        <v-data-table
            :headers="computedHitterHeader"
            :items="computedHittersOnly"
            :items-per-page="3"
            class="elevation-1 projection-table"
            mobile-breakpoint="0"
            calculate-widths
            sort-by="Name"
            :search="search"
            hide-default-footer
        >
          <!-- header -->
          <template
              v-for="(h, index) in computedHitterHeader"
              v-slot:[`header.${h.value}`]="{ computedHitterHeader }"
          >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

            <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
          </template>
          <!-- header -->

          <!-- date -->
          <template v-slot:item.DateTime="{ item }">
            <p>{{ item.DateTime | DatetimeFormat }}</p>
          </template>

          <!--//* matchup -->
          <template v-slot:item.Game="{ item }">
            <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
              {{ item.Opponent }}&nbsp;
              <small class="black--text">@</small>
              <span>
              {{ item.Team }}
            </span>
            </p>

            <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
              {{ item.Team }}&nbsp;
              <small class="black--text">@</small>
              <span>
              {{ item.Opponent }}
            </span>
            </p>
          </template>
          <!--//* matchup ends -->

          <template v-slot:item.ProfilePic="{ item }">
            <!-- //* avatar -->
            <v-avatar width="35" height="40">
              <img :src="item.ProfilePic"/>
            </v-avatar>
            <!-- //* avatar ends-->
          </template>

          <!-- CalFantasyPoints -->
          <template v-slot:item.CalFantasyPoints="{ item }">
            <p v-if="item.CalFantasyPoints == ''">_</p>
            <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceFantasyPoints="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
            >
              Over
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalFantasyPoints) >= 33"
            >
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
            >
              Under
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalFantasyPoints) < -33"
            >
              Under
            </p>
          </template>

          <!-- CalStrikeouts -->
          <template v-slot:item.CalStrikeouts="{ item }">
            <p v-if="item.CalStrikeouts == ''">_</p>
            <p v-else>{{ parseFloat(item.CalStrikeouts).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceStrikeout="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalStrikeouts) >= 0 &&
              parseFloat(item.CalStrikeouts) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalStrikeouts) >= 15 &&
              parseFloat(item.CalStrikeouts) <= 33
            "
            >
              Over
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalStrikeouts) >= 33"
            >
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalStrikeouts) < 0 &&
              parseFloat(item.CalStrikeouts) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalStrikeouts) <= -15 &&
              parseFloat(item.CalStrikeouts) >= -33
            "
            >
              Under
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalStrikeouts) < -33"
            >
              Under
            </p>
          </template>

          <!-- CalHits -->
          <template v-slot:item.CalHits="{ item }">
            <p v-if="item.CalHits == ''">_</p>
            <p v-else>{{ parseFloat(item.CalHits).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceHit="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalHits) >= 0 && parseFloat(item.CalHits) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalHits) >= 15 && parseFloat(item.CalHits) <= 33
            "
            >
              Over
            </p>

            <p class="dark-green" v-else-if="parseFloat(item.CalHits) >= 33">
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalHits) < 0 && parseFloat(item.CalHits) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalHits) <= -15 && parseFloat(item.CalHits) >= -33
            "
            >
              Under
            </p>

            <p class="dark-green" v-else-if="parseFloat(item.CalHits) < -33">
              Under
            </p>
          </template>

          <!-- CalRuns -->
          <template v-slot:item.CalRuns="{ item }">
            <p v-if="item.CalRuns == ''">_</p>
            <p v-else>{{ parseFloat(item.CalRuns).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceRun="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalRuns) >= 0 && parseFloat(item.CalRuns) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalRuns) >= 15 && parseFloat(item.CalRuns) <= 33
            "
            >
              Over
            </p>

            <p class="dark-green" v-else-if="parseFloat(item.CalRuns) >= 33">
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalRuns) < 0 && parseFloat(item.CalRuns) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalRuns) <= -15 && parseFloat(item.CalRuns) >= -33
            "
            >
              Under
            </p>

            <p class="dark-green" v-else-if="parseFloat(item.CalRuns) < -33">
              Under
            </p>
          </template>

          <!--total base  -->
          <template v-slot:item.CalTotalBases="{ item }">
            <p v-if="item.CalTotalBases == ''">_</p>
            <p v-else>{{ parseFloat(item.CalTotalBases).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceTotalbase="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalTotalBases) >= 0 &&
              parseFloat(item.CalTotalBases) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalTotalBases) >= 15 &&
              parseFloat(item.CalTotalBases) <= 33
            "
            >
              Over
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalTotalBases) >= 33"
            >
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalTotalBases) < 0 &&
              parseFloat(item.CalTotalBases) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalTotalBases) <= -15 &&
              parseFloat(item.CalTotalBases) >= -33
            "
            >
              Under
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalTotalBases) < -33"
            >
              Under
            </p>
          </template>

          <!-- Runs battted-->
          <template v-slot:item.CalRunsBattedIn="{ item }">
            <p v-if="item.CalRunsBattedIn == ''">_</p>
            <p v-else>{{ parseFloat(item.CalRunsBattedIn).toFixed(2) }}%</p>
          </template>

          <template v-slot:item.confidenceRunBatted="{ item }">
            <p
                class="light-green"
                v-if="
              parseFloat(item.CalRunsBattedIn) >= 0 &&
              parseFloat(item.CalRunsBattedIn) < 15
            "
            >
              Over
            </p>
            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalRunsBattedIn) >= 15 &&
              parseFloat(item.CalRunsBattedIn) <= 33
            "
            >
              Over
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalRunsBattedIn) >= 33"
            >
              Over
            </p>

            <p
                class="light-green"
                v-else-if="
              parseFloat(item.CalRunsBattedIn) < 0 &&
              parseFloat(item.CalRunsBattedIn) >= -15
            "
            >
              Under
            </p>

            <p
                class="medium-green"
                v-else-if="
              parseFloat(item.CalRunsBattedIn) <= -15 &&
              parseFloat(item.CalRunsBattedIn) >= -33
            "
            >
              Under
            </p>

            <p
                class="dark-green"
                v-else-if="parseFloat(item.CalRunsBattedIn) < -33"
            >
              Under
            </p>
          </template>
        </v-data-table>
      </template>


      <!--//? pitchers  -->
      <v-card-subtitle class="overline font-weight-bold">
        Pitchers
      </v-card-subtitle>
      <v-data-table
          :headers="computedPitcherHeader"
          :items="computedPitchersOnly"
          :items-per-page="3"
          class="elevation-1 projection-table"
          mobile-breakpoint="0"
          calculate-widths
          sort-by="Name"
          :search="search"
          hide-default-footer
      >
        <!-- header -->
        <template
            v-for="(h, index) in computedPitcherHeader"
            v-slot:[`header.${h.value}`]="{ computedPitcherHeader }"
        >
          <span class="team-w-mg" :key="h.text" v-if="h.img">
            <span>{{ h.text }}</span>
            <v-avatar size="20"> <img :src="h.img"/></v-avatar>
          </span>

          <span class="team-w-mg" v-else :key="index">{{ h.text }}</span>
        </template>
        <!-- header -->

        <!-- date -->
        <template v-slot:item.DateTime="{ item }">
          <p>{{ item.DateTime | DatetimeFormat }}</p>
        </template>

        <template v-slot:item.ProfilePic="{ item }">
          <!-- //* avatar -->
          <v-avatar width="35" height="40">
            <img :src="item.ProfilePic"/>
          </v-avatar>
          <!-- //* avatar ends-->
        </template>

        <!--//* matchup -->
        <template v-slot:item.Game="{ item }">
          <p class="body-2" v-if="item.HomeOrAway == 'HOME'">
            {{ item.Opponent }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Team }}
            </span>
          </p>

          <p class="body-2" v-if="item.HomeOrAway == 'AWAY'">
            {{ item.Team }}&nbsp;
            <small class="black--text">@</small>
            <span>
              {{ item.Opponent }}
            </span>
          </p>
        </template>
        <!--//* matchup ends -->

        <!-- CalFantasyPoints -->
        <template v-slot:item.CalFantasyPoints="{ item }">
          <p v-if="item.CalFantasyPoints == ''">_</p>
          <p v-else>{{ parseFloat(item.CalFantasyPoints).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceFantasyPoints="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalFantasyPoints) >= 0 &&
              parseFloat(item.CalFantasyPoints) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) >= 15 &&
              parseFloat(item.CalFantasyPoints) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFantasyPoints) >= 33"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) < 0 &&
              parseFloat(item.CalFantasyPoints) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalFantasyPoints) <= -15 &&
              parseFloat(item.CalFantasyPoints) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalFantasyPoints) < -33"
          >
            Under
          </p>
        </template>

        <!-- CalHits -->
        <template v-slot:item.CalHits="{ item }">
          <p v-if="item.CalHits == ''">_</p>
          <p v-else>{{ parseFloat(item.CalHits).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceHits="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalHits) >= 0 && parseFloat(item.CalHits) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalHits) >= 15 && parseFloat(item.CalHits) <= 33
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalHits) >= 33">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalHits) < 0 && parseFloat(item.CalHits) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalHits) <= -15 && parseFloat(item.CalHits) >= -33
            "
          >
            Under
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalHits) < -33">
            Under
          </p>
        </template>

        <!-- CalRuns -->
        <template v-slot:item.CalRuns="{ item }">
          <p v-if="item.CalRuns == ''">_</p>
          <p v-else>{{ parseFloat(item.CalRuns).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceRuns="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalRuns) >= 0 && parseFloat(item.CalRuns) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRuns) >= 15 && parseFloat(item.CalRuns) <= 33
            "
          >
            Over
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalRuns) >= 33">
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalRuns) < 0 && parseFloat(item.CalRuns) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalRuns) <= -15 && parseFloat(item.CalRuns) >= -33
            "
          >
            Under
          </p>

          <p class="dark-green" v-else-if="parseFloat(item.CalRuns) < -33">
            Under
          </p>
        </template>

        <!-- CalStrikeouts -->
        <template v-slot:item.CalStrikeouts="{ item }">
          <p v-if="item.CalStrikeouts == ''">_</p>
          <p v-else>{{ parseFloat(item.CalStrikeouts).toFixed(2) }}%</p>
        </template>

        <template v-slot:item.confidenceStrikeouts="{ item }">
          <p
              class="light-green"
              v-if="
              parseFloat(item.CalStrikeouts) >= 0 &&
              parseFloat(item.CalStrikeouts) < 15
            "
          >
            Over
          </p>
          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalStrikeouts) >= 15 &&
              parseFloat(item.CalStrikeouts) <= 33
            "
          >
            Over
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalStrikeouts) >= 33"
          >
            Over
          </p>

          <p
              class="light-green"
              v-else-if="
              parseFloat(item.CalStrikeouts) < 0 &&
              parseFloat(item.CalStrikeouts) >= -15
            "
          >
            Under
          </p>

          <p
              class="medium-green"
              v-else-if="
              parseFloat(item.CalStrikeouts) <= -15 &&
              parseFloat(item.CalStrikeouts) >= -33
            "
          >
            Under
          </p>

          <p
              class="dark-green"
              v-else-if="parseFloat(item.CalStrikeouts) < -33"
          >
            Under
          </p>
        </template>
      </v-data-table>
    </v-card>

    <!-- update Modal -->
    <div v-if="UpgradeModal" class="upgrade-dialog">
      <v-dialog
          overlay-opacity="0.97"
          persistent
          v-model="UpgradeModal"
          max-width="350"
      >
        <v-card>
          <v-toolbar dense color="#00E676" class="text-h6" dark>
            Get Full Access
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="text-center text-h6 font-weight-bold pa-1">
            Upgrade Now & Get Access to ALL Features.
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1 white--text" text @click="goBack">
              No, Thanks
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1 white--text" text @click="goToUpgrade">
              Upgrade Now
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- update Modal ends..-->
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "MlbDemoProjection",
  data() {
    return {
      switch1: true,
      UpgradeModal: false,
      search: "",
      operator: localStorage.getItem("operator"),
      // switch2: false,
      hittersHeader: [
        {
          text: "",
          value: "ProfilePic",
          sortable: false,
          width: "70",
        },
        {
          text: "Player Name",
          value: "Name",
          width: "150",
        },
        {
          text: "Team",
          value: "Team",
          width: "100",
        },
        {
          text: "Opp",
          value: "Game",
          width: "120",
        },

        {
          text: "Date",
          value: "DateTime",
          width: "150",
        },

        // *
        {
          text: "Fantasy Points",
          value: "FantasyFantasyPoints",
          width: "110",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyFantasyPoints",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalFantasyPoints",
        },

        {
          text: "Confidence",
          value: "confidenceFantasyPoints",
          sortable: false,
          width: "130",
        },

        // *
        {
          text: "Strikeouts",
          value: "FantasyStrikeouts",
          img: "/favicon.ico",
          width: "110",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyStrikeouts",
          // img: '/img/monkeyKnife.jpeg',
          width: "110",
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalStrikeouts",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceStrikeout",
          sortable: false,
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Hit",
          value: "FantasyHits",
          width: "110",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyHits",
          width: "110",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalHits",
          width: "110",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidenceHit",
          width: "130",
        },

        // *
        {
          text: "Runs batted in",
          value: "FantasyRunsBattedIn",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyRunsBattedIn",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalRunsBattedIn",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceRunBatted",
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Total bases",
          value: "FantasyTotalBases",
          width: "100",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyTotalBases",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalTotalBases",
          width: "110",
        },

        {
          text: "Confidence",
          value: "confidenceTotalbase",
          width: "130",
        },

        //*
        {
          text: "Runs",
          value: "FantasyRuns",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyRuns",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalRuns",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceRun",
          width: "130",
          class: "black--text",
        },
      ],

      pitchersHeader: [
        {
          text: "",
          value: "ProfilePic",
          sortable: false,
          width: "70",
        },
        {
          text: "Player Name",
          value: "Name",
          width: "150",
        },
        {
          text: "Opp",
          value: "Game",
          width: "120",
        },

        {
          text: "Team",
          value: "Team",
          width: "100",
        },

        {
          text: "Date",
          value: "DateTime",
          width: "150",
        },

        // *
        {
          text: "Fantasy Points",
          value: "FantasyFantasyPoints",
          img: "/favicon.ico",
          width: "110",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyFantasyPoints",
          // img: '/img/monkeyKnife.jpeg',
          width: "110",
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalFantasyPoints",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceFantasyPoints",
          sortable: false,
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Hits",
          value: "FantasyHits",
          width: "110",
          img: "/favicon.ico",
        },

        {
          text: "O/U",
          value: "MonkeyHits",
          width: "110",
          // img: '/img/monkeyKnife.jpeg',
        },

        {
          text: "% Diff",
          value: "CalHits",
          width: "110",
        },

        {
          text: "Confidence",
          sortable: false,
          value: "confidenceHits",
          width: "130",
        },

        // *
        {
          text: "Runs",
          value: "FantasyRuns",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyRuns",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalRuns",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceRuns",
          width: "130",
          class: "black--text",
        },

        // *
        {
          text: "Strikeouts",
          value: "FantasyStrikeouts",
          width: "100",
          img: "/favicon.ico",
          class: "black--text",
        },

        {
          text: "O/U",
          value: "MonkeyStrikeouts",
          width: "100",
          // img: '/img/monkeyKnife.jpeg',
          class: "black--text",
        },

        {
          text: "% Diff",
          value: "CalStrikeouts",
          width: "110",
          class: "black--text",
        },

        {
          text: "Confidence",
          value: "confidenceStrikeouts",
          width: "130",
          class: "black--text",
        },
      ],
    };
  },

  computed: {
    ...mapState("MlbModule", ["mlb_props"]),
    ...mapState("userModule", ["userState"]),

    computedHitterHeader() {
      if (this.switch1) {
        return this.hittersHeader;
      } else if (!this.switch1) {
        let newHeader = this.hittersHeader.filter((column) => {
          return (
              !column.value.includes("MonkeyFantasyPoints") &&
              !column.value.includes("CalFantasyPoints") &&
              !column.value.includes("confidenceFantasyPoints") &&
              !column.value.includes("MonkeyStrikeouts") &&
              !column.value.includes("CalStrikeouts") &&
              !column.value.includes("confidenceStrikeout") &&
              !column.value.includes("MonkeyHits") &&
              !column.value.includes("CalHits") &&
              !column.value.includes("confidenceHit") &&
              !column.value.includes("MonkeyRunsBattedIn") &&
              !column.value.includes("CalRunsBattedIn") &&
              !column.value.includes("confidenceRunBatted") &&
              !column.value.includes("MonkeyRuns") &&
              !column.value.includes("CalRuns") &&
              !column.value.includes("confidenceRun") &&
              !column.value.includes("MonkeyTotalBases") &&
              !column.value.includes("CalTotalBases") &&
              !column.value.includes("confidenceTotalbase")
          );
        });
        return newHeader;
      }
    },

    computedPitcherHeader() {
      if (this.switch1) {
        return this.pitchersHeader;
      } else if (!this.switch1) {
        let newHeader = this.pitchersHeader.filter((column) => {
          return (
              !column.value.includes("MonkeyFantasyPoints") &&
              !column.value.includes("CalFantasyPoints") &&
              !column.value.includes("confidenceFantasyPoints") &&
              !column.value.includes("MonkeyHits") &&
              !column.value.includes("CalHits") &&
              !column.value.includes("confidenceHits") &&
              !column.value.includes("MonkeyRuns") &&
              !column.value.includes("CalRuns") &&
              !column.value.includes("confidenceRuns") &&
              !column.value.includes("MonkeyStrikeouts") &&
              !column.value.includes("CalStrikeouts") &&
              !column.value.includes("confidenceStrikeouts")
          );
        });
        return newHeader;
      }
    },

    computedHittersOnly() {
      if (this.mlb_props.teams) {
        return this.mlb_props.teams
            .filter((_player) => {
              return !_player.Position.includes("P");
            })
            .slice(0, 3);
      }
    },

    computedPitchersOnly() {
      if (this.mlb_props.teams) {
        return this.mlb_props.teams
            .filter((_player) => {
              return _player.Position.includes("P");
            })
            .slice(0, 3);
      }
    },
  },

  created() {
    this.fetchNhlPropsData();
  },

  beforeMount() {
    if (this.userState) {
      if (this.userState.plantype == "Free") {
        this.UpgradeModal = true;
      } else {
        this.UpgradeModal = false;
      }
    }
  },

  methods: {
    fetchNhlPropsData() {
      this.$store.dispatch("MlbModule/getMlbProps");
    },

    goBack() {
      this.$router.go(-1);
    },

    goToUpgrade() {
      this.$router.push({name: "upgradePlan"});
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table
>>> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

span.team-w-mg {
  /* display: flex !important; */
  float: left;
}

.theme--light.v-data-table
>>> .v-data-table__wrapper
> table
> thead
> tr:last-child
> th.black--text {
  background-color: #cfd8dc !important;
}

.projection-table >>> .v-data-table-header__icon {
  opacity: 1;
}

.light-green {
  background-clip: #99cc99;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.medium-green {
  background-color: #33cc66;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}

.dark-green {
  background-color: #336633;
  padding: 5px;
  border-radius: 3px;
  color: white;
  text-align: center;
  font-weight: 800;
}
</style>
